import React from "react";
import { Link } from "react-router-dom";
import estilo from "./styles/Pie.module.css";

function Pie() {
  return (
    <div className={estilo.pie}>
      <p>
        Todos los derechos reservados a
        <Link to={"/"}>
          <b> MundoAnime</b>
        </Link>
      </p>
    </div>
  );
}

export default Pie;
